import { Box, useTheme } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";

export default function ListFilterBar({ children }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const cardBg = isDark ? "rgba(255,255,255,0.03)" : "#ffffff";
  const accent = theme.palette.secondary.main;
  const border = isDark ? "rgba(29,158,117,0.14)" : "rgba(29,158,117,0.16)";

  return (
    <Box sx={{
      display: "flex", alignItems: "center", flexWrap: "wrap", gap: "0.75rem",
      p: "0.75rem 1rem",
      backgroundColor: cardBg,
      border: `1px solid ${border}`,
      borderRadius: "10px",
    }}>
      <FilterListIcon sx={{ fontSize: "16px", color: accent }} />
      {children}
    </Box>
  );
}
